<div
  #specificContainer
  class="iu-specific-window iu-specific-window-container operation-management-window no-overflow-x"
  [attr.data-cy-specific-window-name]="name">
  <button class="p-button settings" icon="fas fa-cog" pButton (click)="isSidebarOpen = !isSidebarOpen">
    <!-- <i class="fas fa-cog" aria-hidden="true"></i> -->
  </button>
  <div #dynContainer>
    <button
      class="p-button tree-maintenance-main-btn"
      data-cy="button-saveTree"
      icon="icon-save3x"
      pButton
      showDelay="250"
      tooltipPosition="top"
      type="button"
      [disabled]="!treeData?.treeNodes"
      [hideDelay]="250"
      [life]="3000"
      pTooltip="{{ 'menuBarDetails.save' | translate }}"
      (mouseup)="$event.button === 0 ? saveTree($event) : null">
      <!-- <i class="icon-save3x" style="padding: 0" aria-hidden="true"></i> -->
    </button>
    <button
      class="p-button tree-maintenance-main-btn"
      data-cy="button-refreshData"
      icon="icon-refresh3x"
      pButton
      showDelay="250"
      tooltipPosition="top"
      type="button"
      [disabled]="!treeData?.treeNodes"
      [hideDelay]="250"
      [life]="3000"
      pTooltip="{{ 'menuBarDetails.refresh' | translate }}"
      (mouseup)="$event.button === 0 ? refresh($event) : null">
      <!-- <i class="icon-refresh3x" style="padding: 0" aria-hidden="true"></i> -->
    </button>
    <ng-template iuDynamicContainer />
  </div>

  <div class="split-view" [style.height]="splitHeight">
    <as-split [gutterSize]="8" [unit]="'percent'">
      <as-split-area [lockSize]="false" [size]="50">
        <div class="tree-maintenance-left-container">
          <div [style.height]="'100%'" [style.width]="splitTreeWidth">
            @if (treeID && treeID.id > 0) {
              <div #searchTreeDiv class="tree-maintenance-left-search-zone">
                <iu-input-text-ui
                  #searchTreeInputComponent
                  [cssGrid]="'p-col-6'"
                  [data]="{ columnName: 'searchInTree' }"
                  [fieldValue]="treeSearchValue"
                  [isStandalone]="true"
                  [label]="'tree-maintenance.search-in-tree' | translate"
                  [overridedCSS]="{ width: '250px' }"
                  (fieldValueChange)="!isLetterByLetterSearch ? searchFromFieldValue($event) : null" />
              </div>
            }
            <div class="tree-maintenance-left-tree" [style.height]="treeHeight">
              @if (treeNodes && treeNodes.length) {
                <p-tree
                  [draggableNodes]="true"
                  [droppableNodes]="true"
                  [loading]="isTreeLoading"
                  [loadingIcon]="'tree-maintenance-spinner-loading fas fa-circle-notch'"
                  [selectionMode]="'multiple'"
                  [style]="{ overflow: 'auto', height: '100%', width: '100%' }"
                  [trackBy]="trackByFn"
                  [value]="treeNodes"
                  [(selection)]="selectedTreeNodes"
                  (onNodeCollapse)="collapseNode($event)"
                  (onNodeDrop)="dropNode($event)"
                  (onNodeExpand)="expandNode($event)" />
              }
            </div>
          </div>
          <div #leftBtnContainer class="tree-maintenance-left-btn-container">
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-double-up"
              icon="fas fa-angle-double-up"
              pButton
              type="button"
              (click)="stepUp($event, '*')">
              <!-- <i class="fas fa-angle-double-up" aria-hidden="true"></i> -->
            </button>
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-up"
              icon="fas fa-angle-up"
              pButton
              type="button"
              [disabled]="isMovementDisabled"
              (click)="stepUp($event)">
              <!-- <i class="fas fa-angle-up" aria-hidden="true"></i> -->
            </button>
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-step-in"
              icon="fas fa-indent"
              pButton
              type="button"
              [disabled]="isMovementDisabled"
              (click)="stepIn($event)">
              <!-- <i class="fas fa-indent" aria-hidden="true"></i> -->
            </button>
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-right"
              icon="fas fa-angle-right"
              pButton
              type="button"
              (click)="deleteFromTree($event)">
              <!-- <i class="fas fa-angle-right" aria-hidden="true"></i> -->
            </button>
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-left"
              icon="fas fa-angle-left"
              pButton
              type="button"
              (click)="addInTree($event)">
              <!-- <i class="fas fa-angle-left" aria-hidden="true"></i> -->
            </button>
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-step-out"
              icon="fas fa-outdent"
              pButton
              type="button"
              [disabled]="isMovementDisabled"
              (click)="stepOut($event)">
              <!-- <i class="fas fa-outdent" aria-hidden="true"></i> -->
            </button>
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-down"
              icon="fas fa-angle-down"
              pButton
              type="button"
              [disabled]="isMovementDisabled"
              (click)="stepDown($event)">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </button>
            <button
              class="p-button tree-maintenance-left-btn"
              data-cy="tree-maintenance-btn-double-down"
              icon="fas fa-angle-double-down"
              pButton
              type="button"
              (click)="stepDown($event, '*')">
              <!-- <i class="fas fa-angle-double-down" aria-hidden="true"></i> -->
            </button>
          </div>
        </div>
      </as-split-area>
      <as-split-area [lockSize]="false" [size]="50">
        @if (colTableHeaders && colTableHeaders.length) {
          <div class="tree-maintenance-right-container">
            <div #searchGridDiv class="tree-maintenance-right-search-zone">
              <div class="tree-maintenance-right-warning">
                <i
                  aria-hidden="true"
                  class="fas fa-exclamation-triangle"
                  tooltipPosition="bottom"
                  [hideDelay]="250"
                  [life]="3000"
                  pTooltip="{{ 'tree-maintenance.warning-search' | translate }}"></i>
              </div>
              <div class="tree-maintenance-right-search-field">
                <iu-input-text-ui
                  [cssGrid]="'p-col-12'"
                  [data]="{ columnName: 'searchInGrid' }"
                  [fieldValue]="gridSearchValue"
                  [isStandalone]="true"
                  [label]="'tree-maintenance.search-in-grid' | translate"
                  [overridedCSS]="{ width: '250px' }"
                  (fieldValueChange)="searchInGrid($event)" />
              </div>
            </div>
            <div [style.height]="gridHeight">
              <iu-grid-tab-infinity-scroll-ui
                #gridTab
                data-cy-grid-tablename="tree-maintenance-search-grid"
                [data]="{
                  frameworkComponents,
                  columnsTableHeader: colTableHeaders,
                  AD_FormDetail_ID: undefined,
                  searchColumns,
                }"
                [forcePaginationAutoPageSize]="true"
                [getDataGrid]="getDataGrid"
                [isSearch]="true"
                [overridedTableHeight]="true"
                [parentFormID]="fields[0]?.formDetailId"
                [rowClassRules]="rowClassRules"
                [tableHeight]="'calc(100% - 5px)'"
                [windowType]="IupicsMenuType.FORM"
                (multiSelectEmitter)="onSelectOnGrid($event)" />
            </div>
          </div>
        }
      </as-split-area>
    </as-split>
  </div>

  <p-sidebar
    position="right"
    styleClass="p-sidebar-md optionalFilterPanel"
    [baseZIndex]="0"
    [(visible)]="isSidebarOpen">
    <h1 class="iu-notification-center-title">
      {{ 'specificWindow.optionalFilters' | translate }}
    </h1>
    <div class="optionalFields">
      <ng-template #optional />
      <div>
        <iu-input-switch-ui
          [fieldValue]="isLetterByLetterSearch ? 'Y' : 'N'"
          [isStandalone]="true"
          [label]="'tree-maintenance.letter-by-letter' | translate"
          (fieldValueModified)="setConfig('isLetterByLetterSearch', $event)" />
      </div>
    </div>
  </p-sidebar>
</div>

<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    [angularStyle]="customFormModalBodyCss"
    [isModalDisplay]="displayFormUI"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false, sourceComponent: this }})">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
